import { animated, useSpringRef, useTransition } from '@react-spring/web';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import { Status } from './types';

export function Swap({
  className,
  status,
  ready,
  search,
  error,
  processing,
  success,
  inContainer,
}: {
  className?: string;
  inContainer?: boolean;
  status: Status;
  search: ReactNode;
  ready: ReactNode;
  error: ReactNode;
  processing: ReactNode;
  success: ReactNode;
}) {
  const transRef = useSpringRef();

  const maxWidth = useMemo(() => {
    if (inContainer) {
      if (status === 'processing') {
        return 'max-w-md';
      }
      if (status === 'ready') {
        return 'max-w-2xl';
      }
      return 'max-w-lg';
    }

    return 'max-w-full';
  }, [status, inContainer]);

  const transitions = useTransition(status, {
    ref: transRef,
    keys: null,
    config: {
      duration: 300,
    },
    from: {
      opacity: 0,
    },
    enter: {
      opacity: 1,
    },
    leave: {
      opacity: 0,
      position: 'absolute', // the departing item doesnt effect layout
      left: 0,
      right: 0,
    },
  });

  // trigger transition change
  useEffect(() => {
    transRef.start();
  }, [transRef, status]);

  return (
    <div
      className={`bg-gray-50 w-full ${maxWidth} ${
        className ?? ''
      } transition-[max-width] duration-300 overflow-hidden relative`}
    >
      {transitions((style, activeView) => {
        return (
          <animated.div style={style} key={activeView}>
            {activeView === 'ready' && (!!search ? search : ready)}
            {activeView === 'processing' && processing}
            {activeView === 'success' && success}
            {activeView === 'error' && error}
          </animated.div>
        );
      })}
    </div>
  );
}

export default Swap;
